// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1HlQk","title":"InfoRow_title__33dJu"};